<template>
    <!-- 详情模块 -->
    <div class="form-wrapper" style="padding-top: 24px">
        <Form ref="infoForm" :model="infoForm" :rules="infoFormRules" inline :label-width="240"  class="form-list key__form">
            <Row :gutter="16">
                <Col span="12">
                    <FormItem label="项目名称" prop="name">
                        <Input v-model="infoForm.name" placeholder="项目名称务必与施工许可证保持一致"></Input>
                    </FormItem>
                </Col>
                <Col span="24">
                    <FormItem label="施工许可证号" prop="builderLicenseNum">
                        <div style="display: flex; flex-wrap: wrap">
                            <Input style="width: 200px; margin-right: 8px;" v-for="(item, index) in buildPermitCodeArr" v-model="item.value" :key="index" placeholder="请输入">
                            <span slot="append" style="cursor: pointer" @click="deletePcode(index)">x</span>
                            </Input>
                            <Button type="primary" @click="addPcode">添 加</Button>
                        </div>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="项目所在地区" prop="areaCodeS">
                        <Cascader v-model="infoForm.areaCodeS" :data="areaList" placeholder="请选择" @on-change='infoCas'></Cascader>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="项目类别" prop="category">
                        <Select v-model="infoForm.category" filterable clearable label-in-value @on-change="infoType">
                            <Option v-for="item in common.projectTypes" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="24">
                    <FormItem label="项目状态" prop="prjStatus">
                        <RadioGroup v-model="infoForm.prjStatus">
                            <Radio v-for="item in common.prjStatusS" :key="item.label" :label="item.value">{{item.label}}</Radio>
                        </RadioGroup>
                    </FormItem>
                </Col>
            </Row>
            <div class="cFlex">
                <Button type="primary" :loading="loadingK" @click="infoOk" style="margin-right: 16px">提 交</Button>
                <Button @click="handleBack">取 消</Button>
            </div>
        </Form>
    </div>
</template>
<script>
    import { getCounties } from '@/api/user'
    export default {
        components: {
        },
        data(){
            return {
                //项目id
                projectId:'',
                loadingK: false,
                buildPermitCodeArr: [{ value: ''}],
                areaList: [],
                infoForm:{
                    name: '',
                    builderLicenseNum: '',
                    category: '',
                    categoryName: '',
                    prjStatus: '',
                    areaCodeS: [],
                    provinceCode: '',
                    provinceName: '',
                    cityCode: '',
                    cityName: '',
                    countyCode: '',
                    countyName: '',
                    areaCode: '',
                    areaName: '',
                },
                infoFormRules: {
                    name: [
                        { required: true,  message: '请输入项目名称', trigger: 'blur' }
                    ],
                    areaCodeS: [
                        { required: true, type:'array', min: 1, message: '项目所在地区不能为空', trigger: 'change' }
                    ],
                    category: [
                        { required: true,  message: '项目类别不能为空', trigger: 'change' }
                    ],
                    prjStatus: [
                        { required: true,  message: '项目状态不能为空', trigger: 'change' }
                    ],
                },
            };
        },
        computed:{

        },
        created(){
            this.projectId= this.$route.query.projectId;
            this.getPageData();
        },
        mounted(){

        },
        watch: {

        },
        methods: {
            handleBack(){
                this.$router.go(-1);
            },
            infoType(data){
                this.infoForm.categoryName = data.label;
            },
            addPcode() {
                this.buildPermitCodeArr.push({ value: ''});
            },
            deletePcode(index) {
                this.buildPermitCodeArr.splice(index, 1);
            },
            infoCas(val, data) {
                const len = data.length;
                this.infoForm.provinceCode = data[len-3].value;
                this.infoForm.provinceName = data[len-3].label;
                this.infoForm.cityCode = data[len-2].value;
                this.infoForm.cityName = data[len-2].label;
                this.infoForm.countyCode = data[len-1].value;
                this.infoForm.areaCode = data[len-1].value;
                this.infoForm.countyName = data[len-1].label;
                this.infoForm.areaName = this.infoForm.provinceName + '-' +this.infoForm.cityName+ '-' +this.infoForm.countyName;
            },
            infoOk(){
                this.$refs.infoForm.validate((valid) => {
                    if (valid) {
                        const arr = this.buildPermitCodeArr.map(item=>{
                            return item.value
                        });
                        this.infoForm.builderLicenseNum = [...new Set(arr)].join(';');
                        this.loadingK = true;
                        this.axios({
                            method: 'post',
                            url:'/project/updateBasicProjectData',
                            data: this.infoForm
                        }).then((res) => {
                            this.loadingK = false;
                            if (res.data.success) {
                                this.$router.go(-1)
                            } else {
                                this.$Modal.error({
                                    title: '提示',
                                    content: '失败，失败原因：' + res.data.errorMsg
                                })
                            }
                        }).catch(() => {
                            this.loadingK = false;
                        });
                    }
                })
            },
            /*获取页面信息*/
            getPageData(){
                const code = localStorage.getItem('tenantAreaCode').slice(0,2) * 10000;
                getCounties(code).then((res)=> {
                    this.areaList = res.data.data || []
                });
                this.axios({
                    method: 'get',
                    url:'/project/getEditProjectDetail',
                    params:{
                        projectId:this.projectId,
                    }
                }).then((response)=>{
                    if(response.data.success){
                        Object.assign(this.infoForm, response.data.data);
                        if(this.infoForm.areaCode) {
                            this.infoForm.areaCodeS = this.infoForm.areaCode.split('-');
                        }
                        if(this.infoForm.builderLicenseNum){
                            const arr = this.infoForm.builderLicenseNum.split(';');
                            this.buildPermitCodeArr = arr.map(item=>{
                                return { value: item }
                            })
                        }
                        this.infoForm.categoryName = this.common.transfer(this.infoForm.category, this.common.projectTypes);
                        const codes = this.infoForm.areaCode.split('-');
                        const names = this.infoForm.areaName.split('-');
                        const len = names.length;
                        this.infoForm.provinceCode = codes[len-3];
                        this.infoForm.provinceName = names[len-3];
                        this.infoForm.cityCode = codes[len-2];
                        this.infoForm.cityName = names[len-2];
                        this.infoForm.countyCode = codes[len-1];
                        this.infoForm.areaCode = codes[len-1];
                        this.infoForm.countyName = names[len-1];
                        this.infoForm.areaName = this.infoForm.provinceName + '-' +this.infoForm.cityName+ '-' +this.infoForm.countyName;

                    }
                });
            },
        }
    };
</script>
